import Immutable from 'immutable';
import {
  FLAG_GETTING_TICKETS,
  GET_TICKETS,
  CLEAR_TICKETS,
  GET_TICKET,
  CLEAR_TICKET,
  FLAG_TICKET_ACTIVITY,
  FLAG_CHANGING_PASSENGER,
  GET_CUSTOMER_UPDATE_HISTORY,
  CLEAR_CUSTOMER_UPDATE_HISTORY,
  FLAG_GETTING_CUSTOMER_UPDATE_HISTORY,
  GET_TICKET_FROM_ITINERARY,
  CLEAR_TICKET_FROM_ITINERARY,
  FLAG_GETTING_TICKET_FROM_ITINERARY,
  PRINT_TICKET_VOUCHER_ON_MOUNT
} from '../../../actions/types';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
    changingPassenger: false,
    customerUpdateHistory: Immutable.Map(),
    loading: false,
    printOnMount: false,
  }),
  itinerary: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_TICKETS:
      return state.setIn(['all', 'loading'], payload);
    case GET_TICKETS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_TICKETS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_TICKET_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_TICKET:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_TICKET:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    case FLAG_CHANGING_PASSENGER:
      return state.setIn(['current', 'changingPassenger'], payload);
    case GET_CUSTOMER_UPDATE_HISTORY:
      return state.setIn(
        ['current', 'customerUpdateHistory'], Immutable.fromJS(payload));
    case CLEAR_CUSTOMER_UPDATE_HISTORY:
      return state.setIn(
        ['current', 'customerUpdateHistory'],
        Immutable.Map()
      );
    case FLAG_GETTING_CUSTOMER_UPDATE_HISTORY:
      return state.setIn(['current', 'loading'], payload);
    case GET_TICKET_FROM_ITINERARY:
      return state.setIn(['itinerary', 'content'], Immutable.Map(payload));
    case CLEAR_TICKET_FROM_ITINERARY:
      return state.setIn(
        ['itinerary', 'content'],
        INITIAL_STATE.getIn(['itinerary', 'content']),
      );
    case FLAG_GETTING_TICKET_FROM_ITINERARY:
      return state.setIn(['itinerary', 'loading'], payload);
    case PRINT_TICKET_VOUCHER_ON_MOUNT:
      return state.setIn(['current', 'printOnMount'], payload);
    default:
      return state;
  }
};
